function slideshowBeforeHero() {
  console.log('slideshowBeforeHero');
    let foundSlideshowFirst = false;
    let foundHeroFirst = false;
    let slideshowEl = null;
    let heroEl = null;
    let sections = document.getElementsByClassName('shopify-section');

    Array.from(sections).forEach((section) => {
        if (section.className.match(/--slideshow/)) {
            slideshowEl = section;
            if (!foundHeroFirst) {
                foundSlideshowFirst = true;
            }
        }
        if (section.id.match(/-hero/)) {
            heroEl = section;
            if (!foundSlideshowFirst) {
                foundHeroFirst = true;
            }
        }
    });

    return {
        foundSlideshowFirst: foundSlideshowFirst,
        slideshowEl: slideshowEl,
        heroEl: heroEl
    };
}

function fixPadding() {
    let data = slideshowBeforeHero();
// 	console.log(data);
    if (data.foundSlideshowFirst === true && window.screen.width < 500) {
        data.slideshowEl.setAttribute("style", "padding-bottom:0;"); 
        data.heroEl.setAttribute("style", "padding-top:0;margin-top:0;");
    }
}

document.addEventListener('DOMContentLoaded', fixPadding);
// if (document.readyState === "interactive" || document.readyState === "complete") {
//   console.log('readystate1', document.readyState );
//   fixPadding();
// } else {
//   console.log('readystate2', document.readyState );
// 	document.addEventListener('DOMContentLoaded', fixPadding);
// }
window.addEventListener("resize", fixPadding);